import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import RobotOutlinedSvg from "@ant-design/icons-svg/es/asn/RobotOutlined";
import AntdIcon from "../components/AntdIcon";
var RobotOutlined = function RobotOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: RobotOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  RobotOutlined.displayName = 'RobotOutlined';
}
export default /*#__PURE__*/React.forwardRef(RobotOutlined);